import { ElementTypes } from '../types/element';

export const ELEMENTS_THAT_CAN_AVOID_COLLISION: { [key in ElementTypes]?: boolean } = {
  [ElementTypes.FieldLongText]: true,
  [ElementTypes.FieldRecordRef]: true,
};

interface IFontWeightOptions {
  [key: string]: {
    name: string;
    value: string;
  }[];
}

export const FONT_WEIGHT_OPTIONS: IFontWeightOptions = {
  'PingFang SC': [
    { name: '100', value: '100' },
    { name: '200', value: '200' },
    { name: '400', value: '400' },
    { name: '500', value: '500' },
    { name: '700', value: '700' },
  ],
  'Times New Roman': [
    { name: '400', value: '400' },
    { name: '700', value: '700' },
  ],
  Georgia: [
    { name: '400', value: '400' },
    { name: '700', value: '700' },
  ],
  Arial: [
    { name: '400', value: '400' },
    { name: '700', value: '700' },
  ],
  Helvetica: [
    { name: '300', value: '300' },
    { name: '400', value: '400' },
    { name: '700', value: '700' },
  ],
  'Courier New': [
    { name: '300', value: '300' },
    { name: '700', value: '700' },
  ],
};

export const FONT_FAMILY = [
  { name: 'PingFang SC', value: 'PingFang SC' },
  { name: 'Times New Roman', value: 'Times New Roman' },
  { name: 'Georgia', value: 'Georgia' },
  { name: 'Arial', value: 'Arial' },
  { name: 'Helvetica', value: 'Helvetica' },
  { name: 'Courier New', value: 'Courier New' },
];
